import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import AgentDashboard from "./AgentDashboard";

// `/` is gated by RequireAuth (and, for agents, RequireOnboarded). Staff go to
// the admin dashboard; self-service agents get their own dashboard here. #50 — a
// principal in their "agent view" (actingAsAgent) stays here on the agent
// dashboard instead of being bounced to the admin console.
export default function Home() {
  const navigate = useNavigate();
  const { user, isStaff, actingAsAgent, loading, refetch } = useAuth();
  const toAdmin = user && isStaff(user) && !actingAsAgent(user);

  // Re-pull the user every time the dashboard is shown so state changed earlier
  // in this session is reflected before the next flow starts. Submitting a first
  // contract request flips the agent to existing (server-side); without this the
  // week-long cached user would keep saying "new" and the next request would
  // wrongly re-present the onboarding contract. AuthProvider is app-level, so the
  // refreshed user is in place before the request wizard mounts (no race).
  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loading || !user) return;
    if (toAdmin) {
      navigate("/admin");
    }
  }, [user, toAdmin, loading, navigate]);

  if (loading || !user || toAdmin) {
    return <h3>Loading...</h3>;
  }
  return <AgentDashboard />;
}
